// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2oiLW","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2CjCG","obliqueLine":"membershipbadge_obliqueLine__1xgFv"};